// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')
// Browser-only common client V2 imports
let mediaQueryManager
if (typeof window === 'object') {
  mediaQueryManager = require('client-v2/common/utils/media-query-manager')
}

const bem = BemEntity('ResponsiveImage')

const SIZES = ['small', 'medium', 'large']

class ResponsiveImage extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      currentSize: null,
      previousSize: null
    }

    this.updateSize = this.updateSize.bind(this)
  }

  componentDidMount() {
    if (mediaQueryManager) {
      mediaQueryManager.addListener(this.updateSize)
      this.updateSize()
    }
  }

  componentWillUnmount() {
    if (mediaQueryManager) {
      mediaQueryManager.removeListener(this.updateSize)
    }
  }

  updateSize() {
    this.setState(state => {
      // Prefer the biggest image we already have cached
      const oldSize = state.currentSize
      const newSize = this.mediaSize()
      const newIndex = SIZES.indexOf(newSize)
      const oldIndex = SIZES.indexOf(oldSize)
      if (newIndex > oldIndex) {
        return {
          currentSize: newSize,
          previousSize: oldSize
        }
      }
      return null
    })
  }

  isDefault() {
    return !this.props.imageUrls
  }

  mediaSize() {
    if (!mediaQueryManager) {
      // Server-side rendering; media queries are not available
      return null
    }
    if (mediaQueryManager.matches('small-and-down')) {
      return 'small'
    }
    if (mediaQueryManager.matches('medium-and-down')) {
      return 'medium'
    }
    return 'large'
  }

  renderImage() {
    const { imageUrls } = this.props
    const { currentSize, previousSize } = this.state
    const sources = []
    let placeholder
    if (imageUrls && currentSize) {
      sources.push(imageUrls[currentSize])
      // Transition from the previous size to the new, larger size
      placeholder = previousSize && imageUrls[previousSize]
    }
    return tag(LazyImage, {
      className: bem.element('image'),
      placeholder,
      sources,
      visible: true
    })
  }

  render() {
    return tag('div', {
      className: classNames(
        this.props.className,
        bem.block({
          default: this.isDefault()
        })
      )
    },
      this.renderImage()
    )
  }
}

ResponsiveImage.propTypes = {
  // Values
  className: PropTypes.string,
  imageUrls: PropTypes.objectOf(PropTypes.string)
}

module.exports = ResponsiveImage
